import React, { useEffect, useState } from "react"
import { useDispatch, useSelector } from "react-redux"
import { Routes, Route, useLocation, Navigate, useNavigate, Link } from "react-router-dom"

import {
  Login,
  Companies,
  DashBoard,
  CreateItemMaster,
  ItemMaster,
  ResetPassword,
  CreateColorMaster,
  ColorMaster,
  PurityMaster,
  CreateShapeMaster,
  CreateAccountMaster,
  AccountMaster,
  CreateMemoEntry,
  MemoEntryMaster,
  CreatePurityMaster,
  ShapeMaster,
  CreateModeSetting,
  CreateInvoiceMaster,
  MemoFinalizeEntry,

} from "./pages/index.js"

import { decryptText, encryptText, linksUrl } from "./constants/enum.js"
import PrivateRoute from "./PrivateRoute.jsx"
import { SideNav, Nav, TokenExpired, ErrorCard } from "./components/index.js"
import { Drawer, IconButton } from "@mui/material"
import { faBoxesPacking, faBoxesStacked, faClosedCaptioning, faFileCirclePlus, faHome, faHomeUser, faListCheck, faPlus, faSquareXmark, faTruckArrowRight, faTruckDroplet, faTruckFast, faTruckLoading, faTruckPickup, faTruckRampBox, faWarning } from "@fortawesome/free-solid-svg-icons"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { toast, ToastContainer } from "react-toastify"
import { menuPages } from "./constants/menuPages.js"
import usePagesTitle from "./constants/pagesTitle.js"
import { Button, Chip } from "@heroui/react"
import { isMobile } from "react-device-detect"
import { resetCompCode } from "./state/companySlice.jsx"
import { setLogout } from "./state/authSlice.jsx"
import { setDetailParams, setNewEntryMode } from "./state/orderSlice.jsx"
import { ModalToastProvider } from "./components/modalToast/ModalToastContext.jsx"



//import Test from "./pages/sample/Test.jsx"

function App() {
  const location = useLocation()
  const { isAuthenticated, tokenExpiry, } = useSelector((state) => state.auth)
  const { compCode, salePerson } = useSelector((state) => state.company)
  let navigate = useNavigate();
  let dispatch = useDispatch();

  const [openDrawer, setOpenDrawer] = useState(false);

  if (tokenExpiry && tokenExpiry != "") {
    const currentTime = new Date().getTime() / 1000;
    let timeRemaining = tokenExpiry - currentTime
    if (currentTime > tokenExpiry) {
      if (!toast.isActive('tknExpiremsg') && !toast.isActive('tknExpire') && !toast.isActive('toast_tkexp') && !toast.isActive('toast_tknf')) {
        toast.error("Session Expired Login In Again...", {
          "position": "top-center",
          toastId: "tknExpire",
          onClose: () => navigate(linksUrl.login)
        })
      }
    }
    if (timeRemaining <= 600) {
      if (!toast.isActive('tknExpiremsg') && !toast.isActive('tknExpire') && !toast.isActive('toast_tkexp') && !toast.isActive('toast_tknf')) {
        toast.warning("Session Expired soon save your work ....", {
          "position": "top-center",
          toastId: "tknExpiremsg"
        })
      }
    }
    // if (timeRemaining <= 600) {
    //   if (!toast.isActive('tknExpiremsg') && !toast.isActive('tknExpire') && !toast.isActive('toast_tkexp') && !toast.isActive('toast_tknf')) {
    //     toast.warning("Token Expired Soon Save Your Work ....", {
    //       "position": "top-center",
    //       toastId: "tknExpiremsg"
    //     })
    //   }
    // }
    // if (currentTime > tokenExpiry) {
    //   if (!toast.isActive('tknExpire') && !toast.isActive('toast_tkexp') && !toast.isActive('toast_tknf')) {
    //     toast.error("Token Expired....", {
    //       "position": "top-center",
    //       toastId: "tknExpire",
    //       onClose: () => navigate(linksUrl.login)
    //     })
    //   }
    // }
  }
  useEffect(() => {
    if (!isAuthenticated)
      navigate(linksUrl.login)

  }, [])


  const hanldeClick = () => {
    setOpenDrawer(false)
    navigate(linksUrl.login)
  }
  const handleNewOrder = () => {
    dispatch(setNewEntryMode(true));
    dispatch(setDetailParams([]));
    navigate(linksUrl.salesOrder.createEntry);
  }
  const pages = menuPages
  const shouldShowSidebar = () => {
    const { pathname } = location
    return !["/login", "/signup", "/sidenav"].includes(pathname) //when path incude this not showside bar
  }
  usePagesTitle();
  return (
    <div>
      <ToastContainer className='toast-container'
        toastClassName="dark-toast"
        progressClassName="progress-toast"
      // closeButton={<FontAwesomeIcon  className=" text-xl text-orange-600 absolute right-4 top-1/2 -translate-y-1/2" icon={faSquareXmark} />}
      />

      <div className="relative min-h-screen bg-gradient-to-t from-gray-50 to-red-100">

        <Drawer open={openDrawer} anchor="top"  >
          <FontAwesomeIcon onClick={hanldeClick} className=" p-3 cursor-pointer text-blue-800 text-3xl absolute right-0" icon={faSquareXmark} />
          <div className="text-center font-semibold p-8 text-gray-800 border-2 border-b-gray-700">
            <FontAwesomeIcon className="text-rose-500" icon={faWarning} ></FontAwesomeIcon> Token Has Expired !
          </div>
        </Drawer>

        {shouldShowSidebar() && <Nav />}
        {shouldShowSidebar() && <SideNav />}


        {/* Routes */}

        <Routes>
          {/* Sample - to check ui*/}
          {/* ene of sample */}
          <Route
            path={linksUrl.login}
            element={
              !isAuthenticated ? <Login /> : <Navigate to={linksUrl.companies} />
            }
          />

          {/* private routes */}
          {/* 
          <Route
            path={linksUrl.dashboard}
            element={
              <PrivateRoute authorized={true}>
                <Dashboard />
              </PrivateRoute>
            }
          /> */}

          {pages.map((page, index) => {
            //if (page !== "report") {
            return (
              <Route
                target={"_blank"}
                key={index}
                path={page.path}
                element={
                  <PrivateRoute page={page}>{page.component}</PrivateRoute>
                }
              />
            )
          })}
        </Routes>

        {shouldShowSidebar() && isMobile && <div id="footer" >
          <div className="mx-auto">
            <div className={`fixed bottom-0 border-t-2 z-[99] border-red-500 left-0 w-full h-14 p-2 bg-gradient-to-t from-red-800 to-red-700 bg-opacity-10 flex justify-center items-center `} >
              <div className=" mx-auto flex gap-4 justify-start items-center">
                <Link to={linksUrl.companies}>
                  <Button size="md" variant="bordered" isIconOnly aria-label="Home" color="default">
                    <FontAwesomeIcon className="text-white  border-0  text-xl" icon={faHomeUser}></FontAwesomeIcon>
                  </Button>
                </Link>
                {/* <FontAwesomeIcon className="text-red-700 p-2 border-1 text-md" icon={faTruckFast}></FontAwesomeIcon> */}
                <Button size="md" isIconOnly aria-label="New Order" onPress={handleNewOrder} variant="bordered" color="default"><FontAwesomeIcon className="text-xl  text-white" icon={faTruckArrowRight} /></Button>
                <Link to={linksUrl.salesOrder.orderMaster}>
                  <Button size="md" isIconOnly aria-label="Order List" variant="bordered" color="default"><FontAwesomeIcon className="text-xl  text-white" icon={faListCheck} /></Button>
                </Link>
              </div>
            </div>
          </div>
        </div>}
      </div>
    </div>
  )
}

export default App
